module.exports = __webpack_public_path__ + "img/index1.9d6d4428.png";